import React from 'react';
import { FormSection, SectionTitle } from '../../styles/wizardStyles';
import FieldGroup from './FieldGroup';

const FormSectionComponent = ({ section, formData, errors, touched, onChange, onBlur, setErrors }) => (
  <FormSection>
    <SectionTitle>{section.title}</SectionTitle>
    <FieldGroup
      fields={section.fields}
      formData={formData}
      errors={errors}
      touched={touched}
      onChange={onChange}
      onBlur={onBlur}
      setErrors={setErrors}
    />
  </FormSection>
);

export default FormSectionComponent;